import { render, staticRenderFns } from "./OsobaGrupaStatusaCreate.vue?vue&type=template&id=4ad967fa&scoped=true&"
import script from "./OsobaGrupaStatusaCreate.vue?vue&type=script&lang=js&"
export * from "./OsobaGrupaStatusaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad967fa",
  null
  
)

export default component.exports